import React from 'react';
import '@vibe/core/tokens';
import { Flex, Icon, Dialog, DialogContentContainer } from '@vibe/core';
import { shift } from '@floating-ui/react-dom';
import { Check as CheckIcon, LearnMore } from '@vibe/icons';

type WhatsThisDialog = {
  headline: React.ReactNode;
  bulletpoints: string[];
  footer: React.ReactNode;
};

export function WhatsThisDialog({ headline, bulletpoints, footer }: WhatsThisDialog) {
  return (
    <Dialog
      middleware={[shift({ mainAxis: false })]}
      zIndex={1005}
      shouldShowOnMount={false}
      showTrigger={['mouseenter']}
      hideTrigger={['mouseleave']}
      position="bottom-end"
      tooltip={true}
      content={
        <>
          <DialogContentContainer type="popover" size="large">
            <h5 style={{ fontWeight: 600 }}>{headline}</h5>
            <div style={{ marginTop: '10px' }}>
              {bulletpoints.map((point, index) => (
                <Flex key={index} gap={8}>
                  <Icon icon={CheckIcon} size={16} ignoreFocusStyle />
                  {point}
                </Flex>
              ))}
            </div>
            <div style={{ marginTop: '10px', color: 'rgb(175, 176, 189)' }}>{footer}</div>
          </DialogContentContainer>
        </>
      }
    >
      <div
        style={{
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          gap: '8px',
        }}
      >
        <span>What's this</span>
        <Icon icon={LearnMore} size={18} ignoreFocusStyle />
      </div>
    </Dialog>
  );
}

export function SpreadsheetTemplatesWhatsThisDialog() {
  return (
    <WhatsThisDialog
      headline={
        <>
          Templates are your central hub to create
          <br />
          and maintain all of your spreadsheets.
        </>
      }
      bulletpoints={[
        'Combine boards in worksheets',
        'Map board to spreadsheet columns',
        'Calculate with advanced formulas',
        'Update board items with formulas',
      ]}
      footer={
        <>
          Spreadsheet templates are visible across all
          <br />
          board views, but set to private by default.
        </>
      }
    />
  );
}

export function SpreadsheetsWhatsThisDialog() {
  return (
    <WhatsThisDialog
      headline={
        <>
          Saved spreadsheets must be seen like
          <br />
          exported files, but stored in the cloud.
        </>
      }
      bulletpoints={[
        'Created from spreadsheet templates',
        'Detached from their template origin',
        'Accessible in the spreadsheet viewer',
        'This is a deprecated feature',
      ]}
      footer={
        <>
          Saved spreadsheets are always attached to
          <br />
          board views and therefore only visible there.
        </>
      }
    />
  );
}

export function LuckysheetWhatsThisDialog() {
  return (
    <WhatsThisDialog
      headline={
        <>
          This is Spreadsheet Gorilla's embedded <br />
          but experimental spreadsheet viewer <br />
          and primarily intended to be used to:
        </>
      }
      bulletpoints={['Preview your template output', 'Check your template configuration', 'Test your custom formulas']}
      footer={<></>}
    />
  );
}
